import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip as BsTooltip } from 'react-bootstrap';

const tooltipProps = {
  tooltipValue: PropTypes.any,
  placement: PropTypes.string,
  delay: PropTypes.any,
};

const Tooltip = ({ children, tooltipValue, placement, delay }) => {
  if (!tooltipValue) return <>{children}</>;
  return (
    <OverlayTrigger
      delay={delay}
      placement={placement}
      overlay={<BsTooltip id="tooltip">{tooltipValue}</BsTooltip>}
    >
      {children}
    </OverlayTrigger>
  );
};

Tooltip.propTypes = tooltipProps;

Tooltip.defaultProps = {
  placement: 'top',
};

export default Tooltip;
